<template>
    <common-modal v-if="isOpen" width="base" :closeOnClickAway="closeOnClickAway" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('pages.auth.verify_email.heading')"
                :content="$t('pages.auth.verify_email.content')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>
            <common-content-wrapper width="small">
                <form-wrapper class="form__fields" :isSubmittable="false">
                    <text-field
                        :label="$t('pages.auth.verify_email.form.email.label')"
                        :placeholder="$t('pages.auth.verify_email.form.email.placeholder')"
                        :isRequired="true"
                        :hasAutofocus="true"
                        :formData="data"
                        :error="errorMessage"
                        valuePath="email"
                        type="email"
                        @change="change($event)"
                    ></text-field>

                    <common-buttons class="modal-buttons">
                        <common-button
                            :label="$t('pages.auth.verify_email.form.cancel')"
                            type="secondary"
                            size="small"
                            :isProcessing="isLoading"
                            @click="emitEvent({ name: 'close' })"
                        ></common-button>
                        <common-button
                            :label="$t('pages.auth.verify_email.form.send_code')"
                            type="primary"
                            size="small"
                            :isProcessing="isLoading"
                            @click="submitEmail"
                        ></common-button>
                    </common-buttons>
                </form-wrapper>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'

    export default {
        mixins: [FormMixin],

        props: {
            isOpen: { type: Boolean, required: true },
            npiNumber: { type: String, default: null },
            token: { type: String, required: true },
            closeOnClickAway: { type: Boolean, default: true },
        },

        data() {
            return {
                isLoading: false,
                errorMessage: '',
                data: {
                    email: '',
                },
            }
        },

        methods: {
            async submitEmail() {
                this.errorMessage = ''

                if (!this.data.email) {
                    this.errorMessage = this.$t('pages.auth.verify_email.errors.email_required')
                    return
                }

                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                if (!emailRegex.test(this.data.email)) {
                    this.errorMessage = this.$t('pages.auth.verify_email.errors.email_invalid')
                    return
                }

                this.isLoading = true

                ReferralsPoolAPI.accessWithToken(this.npiNumber, this.token, this.data.email)
                    .then((response) => {
                        this.emitEvent({
                            name: 'email-submitted',
                            payload: {
                                email: this.data.email,
                                externalProviderReferralsAccessLogId: response.externalProviderReferralsAccessLogId,
                            },
                        })
                    })
                    .catch((error) => {
                        this.error = error.response

                        if (this.error.data[0].field === 'email' && this.error.data[0].code === 'entity.invalid') {
                            this.errorMessage = this.$t('pages.auth.verify_email.errors.email_invalid')
                        } else {
                            this.errorMessage = this.$t('pages.auth.verify_email.errors.failed_to_send_code')
                        }
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
    .modal-buttons {
        margin-top: 20px;
        display: flex;
        gap: 10px;
        justify-content: flex-end;
    }
</style>
